/**
 * The register of web events that are used.
 */
export class WebEvents {
  static CustomerMerged = 'customer-merged';
  static CustomerMergeFailed = 'customer-merge-failed';
  static CustomerUpdated = 'customer-updated';
  static CustomerLoadFailed = 'customer-load-failed';
}
